import { useTranslations } from 'next-intl';
import { SavedList } from 'services/savedLists/types';
import { CellContext } from '@tanstack/react-table';
import {
  CatButton,
  CatIconExternalLinkBox,
  CatTextLink
} from 'components/blocks-components';
import { useEsiteCtx } from 'services/esite/context';
import { getRelativeURLWithParams } from 'utils/url';
import { HEADLESS_SAVED_LISTS, SAVED_LIST_DETAIL_URL } from 'constants/links';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import { useParams } from 'next/navigation';
export interface SavedListTableLinkCellProps {
  info: CellContext<SavedList, unknown>;
  isMobile?: boolean;
  savedListDetailFeatureFlag?: boolean;
}

const SavedListTableLinkCell = ({
  info,
  isMobile = false,
  savedListDetailFeatureFlag = false
}: SavedListTableLinkCellProps) => {
  const t = useTranslations();
  const { catalogId, langId, storeId } = useEsiteCtx();
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params: esiteParams = useParams();
  const getSavedListDetailsPageLink = () =>
    normalizeCommerceLink(
      getRelativeURLWithParams(SAVED_LIST_DETAIL_URL, {
        catalogId,
        langId,
        storeId,
        createdBy: info.row.original.createdBy,
        requisitionListId: info.row.original.shoppingListId,
        requisitionListName: info.row.original.name
      })
    );
  const savedListDetails = getSeoUrl(
    params,
    `${HEADLESS_SAVED_LISTS}/${info.row.original.shoppingListId}`
  );

  const savedDetailsPageLink = savedListDetailFeatureFlag
    ? savedListDetails
    : getSavedListDetailsPageLink();
  if (isMobile) {
    return (
      <CatButton
        hideText
        variant="ghost"
        size="sm"
        href={savedDetailsPageLink}
        target="_blank"
        data-testid="view-saved-list-button"
      >
        <CatIconExternalLinkBox
          data-testid="cat-icon-button"
          slot="before"
          color="information"
        />
      </CatButton>
    );
  }

  return (
    <CatTextLink
      size="sm"
      href={savedDetailsPageLink}
      target="_blank"
      data-testid="view-saved-list-link"
    >
      {t('VIEW')}
    </CatTextLink>
  );
};

export default SavedListTableLinkCell;
